module.exports = __webpack_public_path__ + "media/assets/img/flags/en-AU-6e02b268dd832cf821f5a979231df494.png";